export const disclosure2257 = `

**Age Requirement**
All persons depicted in images or videos accessible through the site or application located at www.batesky.app (the "Site" or "Application") were at least eighteen (18) years old at the time those images or videos were produced.

**Exemption: Content Produced by Third Parties**
The operator of this webstie is not the "producers" of any depictions of actual or simulated sexually explicit conduct. This site is built on the Authenticated Transfer Protocol ("AT Protocol"), a decentralised social networking protocol. The operator does not host, store, copy, transmit, or serve User Content on its own servers. All User Content resides on users' Personal Data Servers ("PDS"). The operator's activities are limited to pointing to content addresses (cryptographic hashes and content identifiers) and surfacing those addresses within the site. The operator is thus exempt from compliance with Section 2257 record-keeping or labelling obligations pursuant to 28 C.F.R. § 75.1(c)(4).

**Exemption: Content Produced by the Operator**
To the extent that any images or videos appear within the site or application for which the operator may be considered the "producer," those images and videos are exempt from the requirements of 18 U.S.C. § 2257 and 28 C.F.R. Part 75 for one or more of the following reasons: (1) they do not portray sexually explicit conduct defined in 18 U.S.C. § 2256(2)(A); (2) they do not portray depictions of the genitals or pubic area created after July 27, 2006; (3) they do not portray simulated sexually explicit activity occurring after the effective date of 18 U.S.C. § 2257A; or (4) they were created before July 3, 1995.

**Designated Records Custodian**
Without limiting in any way the applicability of the above-stated exemptions, the operator has designated the custodian below to be the keeper of original records described in 18 U.S.C. § 2257 and 28 C.F.R. Part 75 for: (1) marketing and advertising materials containing visual depictions of actual or simulated sexually explicit conduct created by the operator to promote the site or application; or (2) materials that are not exempt as described above.

**Title:** The title of this work is: Batesky

**Custodian of Records**
ATTPS Labs Limited
75 Prodromou Avenue, 4th floor
Oneworld Parkview House
2063 Nicosia, Cyprus
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
`